import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { CoreHttpService } from 'src/app/providers/core-http/core-http.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CommonVobReportService extends CoreHttpService {
  public todate = new Date();
  private reportUrl: string = `${environment.apiUrl}/VobReports`;

  constructor(
    private _http: HttpClient,
    router: Router,
    spinner: NgxSpinnerService
  ) {
    super(_http, router, spinner);
  }

  getVobDailyProductionReportData(model: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetVobDailyProductionReportData`, model);
  }

  getVobQualityReportData(model: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetVobQualityReportData`, model);
  }

  getVobCallTimeReportData(model: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetVobCallTimeReportData`, model);
  }

  getVobTatMissing(model: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetVobTatMissing`, model);
  }

  getVobSpecialistBreak(model: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetVobSpecialistBreak`, model);
  }

  getVobVolumeReport(model: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetVobVolumeReport`, model);
  }

  getVobReAssignReport(model: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetVobReAssignReport`, model);
  }

  getVobMissingInformationReport(model: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetVobMissingInformationReport`, model);
  }
  getVobFacilityPayerReport(model: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetVobFacilityPayerReport`, model);
  }

  getVobSpecialistPerformanceReport(model: any): Observable<any> {
    return this.post(`${this.reportUrl}/GetVobSpecialistPerformanceReport`, model);
  }
}
